export const innovation = [

  /*{
    "name": "Ammonia",
    "innovation type": "Science",
    "consequence of": "Language",
    "expansion": "Core",
    "text": "A pungent, bilious substance ideal for crafting leather and treating wounds.\nDeparting survivors gain +1 survival.\nAdd ammonia consequences to the innovation deck."
  },*/
  
  {
    "name": "Ammonia",
    "innovation type": "Science",
    "consequence of": "Language",
    "expansion": "",
    "text": "A pungent, bilious substance ideal for crafting leather and treating wounds.\nDeparting survivors gain +1 survival.\nAdd ammonia consequences to the innovation deck."
  },
  {
    "name": "Bed",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Survival Limit +1\nRest - roll 1d10"
  },
  {
    "name": "Bloodletting",
    "innovation type": "Science",
    "consequence of": "Science",
    "expansion": "",
    "text": "Breathing a Vein - spend 1 resource and roll 1d10."
  },
  {
    "name": "Clan of Death",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "The enduring strength of your clan passes through generations.\nAll newborn survivors gain: +1 Accuracy, +1 Strength, +1 Evasion."
  },
  {
    "name": "Cooking (Innovation)",
    "innovation type": "Science",
    "consequence of": "Science",
    "expansion": "",
    "text": "+1  (At the start of the Settlement Phase, gain +1 endeavor.)\nSurvival Limit: +1\nCooking\nSpend 1 organ and 1 bone to cook stone nose gruel. During the next hunt phase, ignore Starvation."
  },
  {
    "name": "Destiny",
    "innovation type": "Faith",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nThe settlement's future is unavoidable. All survivors gain the Endure survival action.\nEndure: You may spend 7 survival minus your luck to ignore a severe injury before you roll a result."
  },
  {
    "name": "Drums",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "Bone Beats - select one\nYou drum alone. Gain +2 insanity.\nRhythmic trance. Gain +2 survival.\nGain Rhythm Chaser fighting art or Synchronized Strike secret fighting art."
  },
  {
    "name": "Face Painting",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": "Battle Paint - roll 1d10\nFounder's Eye - roll 1d10"
  },
  {
    "name": "Family",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Departing survivors gain +1 survival.\nSurvivors nominated for Intimacy may give\nthemselves a surname if they do not have one.\nA newborn survivor inherits the surname of one\nparent, their weapon type and half (rounded\ndown) of their weapon proficiency levels."
  },
  {
    "name": "Final Fighting Art",
    "innovation type": "Education",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nOnce per showdown, you may select a\ncard from the discard pile or wound stack\nand place it on top of the AI deck."
  },
  {
    "name": "Forbidden Dance",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "When a survivor uses the Synchronized Strike\nsecret fighting art, reroll missed attack rolls once.\nOnce per lifetime - roll 1d10\nAdd forbidden dance consequences to the innovation deck."
  },
  {
    "name": "Guidepost",
    "innovation type": "Other",
    "consequence of": "",
    "expansion": "",
    "text": "The soft glow of its light\nfills the survivors with a\nsense of security.\nDeparting survivors gain +1 survival.\n: The survivor attempts\nto pull the weapon free\nfrom the ground. Roll\n1d10 and add their\nstrength. If the result is\n12+, gain the Lantern Halberd rare gear and\nlose this innovation\n(archive this card)."
  },
  {
    "name": "Heart Flute",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "When a survivor uses the Synchronized Strike fighting art, their attack assist may spend 1 survival to change any monster  to a  FAILURE before any wound attempts are made. Limit, once per attack."
  },
  {
    "name": "Hovel",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Survival Limit: +1\nThe settlement accepts this nightmarish\nlandscape as their home.\nDeparting survivors gain +1 survival.\nAdd hovel consequences to the\ninnovation deck."
  },
  {
    "name": "Inner Lantern",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "The settlement finds the light within.\nAll survivors gain the surge survival action.\nSurge: Once per round, spend 1 survival\nto gain +1  and use it immediately.\n(See detailed rules in rulebook).\nAdd inner lantern consequences to the\ninnovation deck."
  },
  {
    "name": "Language",
    "innovation type": "Starting Innovation",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nAll survivors gain the Encourage survival action.\nEncourage: Once per round, if standing,\nspend 1 survival to call out to a non-deaf\nsurvival. They stand if knocked down.\n(See detailed rules in rulebook).\nAdd language consequences to the\ninnovation deck."
  },
  {
    "name": "Lantern Oven",
    "innovation type": "Science",
    "consequence of": "Science",
    "expansion": "",
    "text": "By agitating lanterns, a source of Heat\nbecomes available to the settlement.\nDeparting Survivors gain +1 survival.\nAdd lantern oven consequences to the\ninnovation deck."
  },
  {
    "name": "Momento Mori",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": "May be used once per settlement phase.\n Nominate a survivor that died in\nthe last showdown and roll 1d10."
  },
  {
    "name": "Nightmare Training",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "Train - lose 3 survival and roll 1d10."
  },
  {
    "name": "Paint",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": "The settlement swells with creative energy. All survivors gain the Dash survival action.\nDash: Once per round, spend 1 survival to gain +1  and use it immediately. (See detailed rules in rulebook.)"
  },
  {
    "name": "Partnership",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": ": Nominate two survivors. They pair\noff, and each gains the Partner ability. A\nsurvivor may be nominated for\nPartnership once per lifetime.\nPartner - \"(Partner's Name)\": When you\nboth Arrive, gain survival up to the\nsurvival limit. Partners may only nominate\neach other for  Intimacy. When a\npartner dies, the remaining partner gains\na random disorder and loses this ability."
  },
  {
    "name": "Pictograph",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": "At the start of a survivor's act, they may\ndecide to skip their act and  Run Away.\nAfter a hunt event is resolved, a survivor may\ndecide it's time to go home and  Run Away.\nAdd pictograph consequences to the\ninnovation deck."
  },
  {
    "name": "Pottery",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": "Survival Limit: +1\n: Fermentation. Spend 1 organ resource and gain 1 Love Juice basic resource. Limit, once per lantern year.\n: Ret. Spend 1 herb resource and gain 1 hide basic resource. Limit, once per lantern year."
  },
  {
    "name": "Records",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "You gain the Scholar of Death secret fighting art.\nYou laboriously create a volume about a monster you have defeated during your lifetime. Add \"Monster Name\" Vol. X where X is the level of the defeated monster, to the Settlement Record Sheet. The work is exhausting, you retire. There can be up to 3 volumes for each monster."
  },
  {
    "name": "Sacrifice",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "Death Ritual - roll 1d10"
  },
  {
    "name": "Saga",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "A telling of the settlement's survival set to\na soft rhythmic beating of drums.\nAll newborn survivors gain: +2 courage, +2 understanding, +2 Hunt XP"
  },
  {
    "name": "Scarification",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "Initiation - Once per lifetime, gain\n+1 courage and roll the hit location die."
  },
  {
    "name": "Scrap Smelting",
    "innovation type": "Science",
    "consequence of": "Science",
    "expansion": "",
    "text": "Purification - roll 1d10\nBuild Blacksmith\n6x bone\n3x scrap"
  },
  {
    "name": "Sculpture",
    "innovation type": "Art",
    "consequence of": "Art",
    "expansion": "",
    "text": ": You create an Inspirational Statue. Skip the\nnext hunt and lose a fighting art. Record this\nfighting art on the Settlement Record Sheet.\nA settlement can only have one Inspirational\nStatue. (You cannot make another! Secret\nFighting arts are not fighting arts!)\n: You study the Inspirational Statue. Roll 1d10.\nOn a 6+, gain the recorded fighting art."
  },
  {
    "name": "Shrine",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "May be used once per settlement phase.\n Armor Ritual - roll 1d10\nAdd shrine consequences to the\ninnovation deck."
  },
  {
    "name": "Song of the Brave",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "The survivors lift their voices into\nthe darkness. On Arrival, each non-deaf\nsurvivor may remove 1 negative\nattribute token.\nDuring the  Overwhelming Darkness story\nevent, each non-deaf survivor may select\nthe Path of the Brave.\nAdd song of the brave consequences to the\ninnovation deck."
  },
  {
    "name": "Storytelling",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "Survival Limit: +1\nStory Time - roll 1d10\nAdd storytelling consequences to the\ninnovation deck."
  },
  {
    "name": "Symposium",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "When a survivor innovates, draw an\nadditional 2 Innovation Cards\nto choose from.\nAdd symposium consequences to the\ninnovation deck."
  },
  {
    "name": "Ultimate Weapon",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nWhen you defeat a monster, gain 1\nmonster resource of your choice from\nits resource deck."
  },
  {
    "name": "Accept Darkness",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "The settlement no longer fears the\ndarkness. Letting go means your resolve\ncannot be cracked.\nAdd +2 to all Brain Trauma rolls."
  },
  {
    "name": "Barbaric",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nBelieve in the power of human strength to overpower any obstacle.\nAll current and newborn survivors gain +1 permanent strength."
  },
  {
    "name": "Cannibalize",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nWhenever a survivor dies, draw 1 basic resource and add it to settlement storage. Do not gain a resource if a survivor is lost, ceases to exist, or is exiled."
  },
  {
    "name": "Collective Toil",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Your settlement leans into the storm. If everyone holds strong, you will triumph.\nAt the start of the settlement phase, gain +1  for every 10 population."
  },
  {
    "name": "Graves",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "All new survivors gain +1 understanding.\nWhen a survivor dies during the hunt or\nshowdown phase, gain +2 .\nWhen a survivor dies during the\nsettlement phase, gain +1 ."
  },
  {
    "name": "Protect the Young",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "The children are the future.\nWhen rolling on the  Intimacy story event,\nroll twice and pick 1 result."
  },
  {
    "name": "Romantic",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nBelieve in the potential for beauty, decency,\nand ingenuity in others.\nWhen you gain a random fighting art, draw 3\nfighting art cards and select 1 to keep."
  },
  {
    "name": "Survival of the Fittest",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nWhen rolling on the  Intimacy story event,\nroll twice and pick the lowest result. All current and newborn survivors gain +1 strength and evasion.\nOnce per lifetime, a survivor may reroll a single roll result. They must keep this new result."
  },
  {
    "name": "Axe Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Bow Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Club Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Dagger Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Fist and Tooth Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Katar Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Grand Weapon Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Spear Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Shield Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "core",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Sword Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "core",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Twilight Sword Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "core",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Whip Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "core",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Scythe Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "Katana Proficiency",
    "innovation type": "Weapon Proficiency",
    "consequence of": "",
    "expansion": "",
    "text": "Specialization: \nMastery: "
  },
  {
    "name": "The Knowledge Worm",
    "innovation type": "",
    "consequence of": "",
    "expansion": "",
    "text": ""
  },
  {
    "name": "Principle: Bonding",
    "innovation type": "Principle",
    "consequence of": "",
    "expansion": "",
    "text": ""
  },
  {
    "name": "Arena",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "Spar - Spend 1 Iron and roll 1d10."
  },
  {
    "name": "Bloodline",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Newborn survivors inherit the following from their parents:\nThe Oracle's Eye, Iridescent Hide, or Pristine ability (choose 1)\nHalf of one parents weapon proficiency levels (rounded up)\nAdd bloodline consequences to the innovation deck."
  },
  {
    "name": "Dragon Speech",
    "innovation type": "Starting Innovation",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nAll survivors gain the Encourage survival action.\nEncourage: Once per round, if standing,\nspend 1 survival to call out to a non-deaf\nsurvival. They stand if knocked down.\n(See detailed rules in rulebook).\nAdd language consequences to the\ninnovation deck."
  },
  {
    "name": "Empire",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Newborn survivors are born with\n+1 permanent strength\nand the Pristine ability.\nPristine: When you suffer a\ndismemebered severe injury, ignore it\nand gain 1 bleeding token."
  },
  {
    "name": "Radiating Orb",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "Departing survivors and newborn\nsurvivors gain +1 survival.\nDeparting survivors with a\nconstellation gain +1 survival.\nAdd lantern oven consequences to the\ninnovation deck."
  },
  {
    "name": "Round Stone Training",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "Train - spend 1 resource and roll 1d10"
  },
  {
    "name": "Subterranean Agriculture",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "If  Black Harvest is not on the timeline,  Underground Sow.\nIf  Black Harvest is on the timeline, you\nmay spend 1 Preserved Caustic Dung to\nincrease its rank by 1 to a maximum rank\nof 3. Limit, once per settlement phase."
  },
  {
    "name": "Petal Spiral",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "Regardless of their Hunt XP, survivors may select Sword for their Weapon Proficiency.\nTrace Petals - roll 1d10"
  },
  {
    "name": "Albedo",
    "innovation type": "Science, Gormchymy",
    "consequence of": "Science, Gormchymy",
    "expansion": "",
    "text": "Once this lantern year - roll 1d10\nAdd albedo consequences to the innovation deck."
  },
  {
    "name": "Citrinitas",
    "innovation type": "Science, Gormchymy",
    "consequence of": "Science, Gormchymy",
    "expansion": "",
    "text": "Survival Limit: +1\nOnce this lantern year - roll 1d10\nAdd citrinitas consequences to the innovation deck."
  },
  {
    "name": "Nigredo",
    "innovation type": "Science, Gormchymy",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nOnce this lantern year - roll 1d10\nAdd nigredo consequences to the innovation deck."
  },
  {
    "name": "Rubedo",
    "innovation type": "Science, Gormchymy",
    "consequence of": "Science, Gormchymy",
    "expansion": "",
    "text": "Once this lantern year - roll 1d10"
  },
  {
    "name": "Black Mask",
    "innovation type": "Other",
    "consequence of": "",
    "expansion": "",
    "text": "Visit the retinue.  Strange Caravan\nFace the Monster - roll 1d10"
  },
  {
    "name": "Stoic Statue",
    "innovation type": "Other",
    "consequence of": "",
    "expansion": "",
    "text": "Worship the monster. You may not depart or endeavor again this settlement phase. Roll 1d10."
  },
  {
    "name": "White Mask",
    "innovation type": "Other",
    "consequence of": "",
    "expansion": "",
    "text": "Visit the retinue.  Strange Caravan\nLeave the monster an offering. Spend 1 resource and roll 1d10."
  },
  {
    "name": "Crimson Candy",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "At the start of the showdown, each\nsurvivor gains  survival.\nCrimson Cannibalism - roll 1d10"
  },
  {
    "name": "Settlement Watch",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "Departing survivors gain +2 survival when\nthey depart for a Nemesis Encounter\nor a Special Showdown.\nNew Recruits - roll 1d10"
  },
  {
    "name": "War Room",
    "innovation type": "Education",
    "consequence of": "Education",
    "expansion": "",
    "text": "Survival Limit: +1\nA dangerous room of plans and tools.\nQuarries cannot move off the hunt board. If the survivors would move backwards on the hunt board, roll 1d10. On a 4+, they don't.\n: The hunt team makes a plan. The group\nmay reroll 1 Hunt Event Table result (d100)\nthis lantern year. They must reroll before\nperforming the event."
  },
  {
    "name": "Dark Water Research",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "Departing survivors gain +2 insanity.\nLight-Forging\nSpend 2x resources and 2x Dark Water to\nincrease the level of Dark Water\nResearch by 1, to a maximum of 3.\n(Update your settlement record sheet)."
  },
  {
    "name": "Choreia",
    "innovation type": "Music",
    "consequence of": "Music",
    "expansion": "",
    "text": "Spider Dance. Nominate a male and a female survivor and roll 1d10."
  },
  {
    "name": "Silk-Refining",
    "innovation type": "Other",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\n  Silk Surgery\nConvert 1 silk resource into\n1 hide basic resource.\nBuild Silk Mill\n2x silk\n1x bone\n1x organ"
  },
  {
    "name": "Aquarobics",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "Survival Limit: +1\nUnderwater Train - roll 1d10"
  },
  {
    "name": "Filleting table",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "Once per settlement phase, if the returning survivors are victorious, gain 1 random basic resource.\nAdvanced Cutting - roll 1d10"
  },
  {
    "name": "Hands of the Sun",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "The settlement embraces their protective feelings. All survivors gain the Overcharge survival action.\nOvercharge: If you have any +1 strength tokens, you may spend 1 survival and remove them all to give your next attack this round gain\nDevastating 1. Limit, once per round.\nAdd hands of the sun consequences to the innovation deck."
  },
  {
    "name": "Sauna Shrine",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "When survivors depart for a Nemesis Encounter or Special Showdown, they\ngain +10 survival.\nTribute - spend 1 organ and roll 1d10"
  },
  {
    "name": "Shadow Dancing",
    "innovation type": "Home",
    "consequence of": "Home",
    "expansion": "",
    "text": "You may only endeavor here if a survivor died during the last hunt or showdown.\nFinal Dance - once per year, roll 1d10"
  },
  {
    "name": "Sun Language",
    "innovation type": "Starting Innovation",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nAll survivors gain the Embolden survival action.\nEmbolden: Once per round, if you have no +1 strength tokens, spend 1 survival to gain a +1 strength token. When you are knocked down, lose all +1 strength tokens.\nAdd Ammonia, Drums, Hovel, Paint,\nSymposium, and Hands of the Sun to the\ninnovation deck."
  },
  {
    "name": "Umbilical Bank",
    "innovation type": "Science",
    "consequence of": "",
    "expansion": "",
    "text": "When a new survivor is born, you may add\n1 Life String strange resource to storage.\nUmbilical Symbiosis\nSpecial Innovate Pottery\n3x organ"
  },
  {
    "name": "Character (Innovation)",
    "innovation type": "Faith",
    "consequence of": "Faith",
    "expansion": "",
    "text": "Survival Limit: +1\nThe settlement values its self-worth and\nappreciates each crack in every stone face.\nWhen a survivor is named, they\ngain a random character card."
  },
  {
    "name": "Morgue",
    "innovation type": "Science",
    "consequence of": "Science",
    "expansion": "",
    "text": "By creating a radiative chamber, a source of\nCooling becomes available to the settlement.\nIf the settlement has Cannibalize, it harvests preserved bodies. At the start of the develop step, gain 1 random basic resource for every 10 survivors in your death count, rounded down."
  },
  {
    "name": "Water of Life",
    "innovation type": "Art, Science, Faith",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit +1\n: Miracle. Remove a disorder of your choice. Limit once per lifetime.\n: False Miracle - roll 1d10."
  },
  {
    "name": "Butchery",
    "innovation type": "Arc, Food, Collective Cognition",
    "consequence of": "",
    "expansion": "",
    "text": "You may now select a weapon type for weapon proficiency.\n: Monster Anatomy Study. Spend 1 organ to gain +1 weapon proficiency. Limit once per lifetime."
  },
  {
    "name": "Nutrition",
    "innovation type": "Arc, Food, Collective Cognition",
    "consequence of": "",
    "expansion": "",
    "text": "Share +1 Forum Knowledge\n: Anthocyanins. Gain +1 lumi.\n: Omega-3. Gain +4 lumi.\n: Protein Training. Gain +1 accuracy and +1 strength. Limit once per lifetime."
  },
  {
    "name": "Romantic (Arc)",
    "innovation type": "Arc, Principle",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nAdd the Romanticism philosophy card to the philosophy deck.\nReduce the lumi cost to learn knowledge at the Forum by 1 (to a minimum of 1)."
  },
  {
    "name": "Sculpture (Arc)",
    "innovation type": "Arc, Art",
    "consequence of": "Arc, Art",
    "expansion": "",
    "text": ": You bare your soul to create an inspirational statue. Skip the\nnext hunt and lose a knowledge (it will be embodied in the statue). Note this on the Settlement Record Sheet.\nA settlement can only ever have one inspirational\nstatue.\nAlways Share this knowledge in addition to others at the Forum. It costs 1 less lumi to gain."
  },
  {
    "name": "Shattered Blade",
    "innovation type": "arc, impermanism",
    "consequence of": "",
    "expansion": "",
    "text": ": Reforge. Spend 1 organ and archive this. Gain the Unbreakable Zanbato pattern gear. With every reforge, the weapon gains +2 strength for the rest of this campaign (note this on your settlement record sheet)."
  },
  {
    "name": "Stone Plate",
    "innovation type": "Arc, Food, Collective Cognition",
    "consequence of": "",
    "expansion": "",
    "text": "The settlement tenderly scrapes together comforting meals. Survivors may claim the Clothed & Satiated armor set bonus card if they meet its requirements."
  },
  {
    "name": "Stone Stairs",
    "innovation type": "Arc, Regalism",
    "consequence of": "",
    "expansion": "",
    "text": "During the settlement phase, if a survivor runs away, is exiled, or dies, they Climb the Stairs instead.\nClimb the Stairs - roll 1d10"
  },
  {
    "name": "Supreme Cuisine",
    "innovation type": "Arc, Food, Collective Cognition",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit +3\nFood is a light in the darkness. Returning survivors get +2 lumi.\n: Monster Style. Select a quarry monster. If the settlement has earned at least 10 CC from the monster, gain its meal gear card."
  },
  {
    "name": "Drafting Table",
    "innovation type": "Seed Pattern",
    "consequence of": "",
    "expansion": "",
    "text": "When a survivor first reaches 3 understanding, gain a Seed Pattern card.\nEndeavor: Practice - roll 1d10."
  },
  {
    "name": "Death Pact",
    "innovation type": "Scout, Law",
    "consequence of": "",
    "expansion": "",
    "text": "When the survivors perish on the hunt or are defeated in the showdown, Logistics of Death.\n: Special Innovate Pictograph (1x hide, 1x organ)"
  },
  {
    "name": "Pictograph (scout)",
    "innovation type": "Scout, Art",
    "consequence of": "Scout, Art",
    "expansion": "",
    "text": "The first time a Level 3+ quarry monster is defeated by survivors accompanied by a scout, gain the Scout Discovery for that monster.\nAdd pictograph consequences to the innovation deck."
  },
  {
    "name": "Song of Concord",
    "innovation type": "Music",
    "consequence of": "",
    "expansion": "",
    "text": "Departing survivors start their hunt with this whispered song, each gaining +5 survival.\nArchive this when you hunt Smog Singers.\nEndeavor: Song of Silence - Roll 1d10"
  },
  {
    "name": "Dream Schematics",
    "innovation type": "Science, Wondrous Design",
    "consequence of": "",
    "expansion": "",
    "text": "At the start of the develop step, a survivor must Build the Dream.\nBuild the Dream - roll 1d10"
  },
  {
    "name": "Dreamless Language",
    "innovation type": "Arc, Starting Innovation",
    "consequence of": "",
    "expansion": "",
    "text": "Survival Limit: +1\nAll survivors gain the Encourage survival action.\nEncourage: Once per round, if standing,\nspend 1 survival to call out to a non-deaf\nsurvivor. They stand if knocked down.\nAdd language consequences to\nthe innovation deck."
  },
  {
    "name": "Silent Dialect",
    "innovation type": "Arc, Starting Innovation",
    "consequence of": "",
    "expansion": "",
    "text": "The settlement develops a silent form of communication to cope with the ever-present din of snoring dreamers. All survivors gain the Fist Pump survival action.\nFist Pump: Once per round, if standing, spend\n1 survival to gesture to a Non-blind Survivor.\nThey stand if knocked down."
  }
];

export default innovation;
